import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader } from 'components/loader/loader';
import { useGlobalState } from 'store/reducers/reducer';
import { confirmEmail, getAccount } from 'store/sagas/sagas';
import { getQueryVariable } from 'utils/url';
export const Confirm = () => {
    const { asyncDispatch } = useGlobalState();
    const navigate = useNavigate();
    const [message, setMessage] = useState('');
    const token = getQueryVariable('t');
    useEffect(() => {
        if (token) {
            asyncDispatch(confirmEmail(token))
                .then(async (data) => {
                setMessage('Thanks for confirming your email.');
                return asyncDispatch(getAccount(data.accessToken));
            })
                .catch((error) => {
                console.error(error);
                setMessage(error.message);
            });
            setTimeout(() => {
                navigate('/account');
            }, 3000);
        }
        else {
            setMessage('Check your email please');
        }
    }, [token]);
    return (React.createElement("div", { className: "account u-flex-row g-page-without-header-footer u-align-vertical-center u-align-horizontal-center" },
        React.createElement("div", { className: "u-flex u-align-vertical-center" }, message ? React.createElement("span", null, message) : React.createElement(Loader, null))));
};
